// Evita que uma resposta lenta e antiga sobrescreva a mais recente:
// cada busca pega um número e só aplica o resultado se ainda for o último.
export const createLatestRequest = () => {
  let current = 0;
  return {
    next: () => {
      current += 1;
      return current;
    },
    isLatest: id => id === current,
  };
};
